module.exports = __webpack_public_path__ + "img/customize.e082d420.png";